var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "button-box clearflex" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.addUserGroup()
                }
              }
            },
            [_vm._v("新增用户群")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "tree-props": { children: "children", hasChildren: "hasChildren" },
            border: "",
            "row-key": "ID",
            stripe: ""
          }
        },
        [
          _c("el-table-column", { attrs: { label: "用户群id", prop: "ID" } }),
          _c("el-table-column", {
            attrs: { label: "用户群名称", prop: "groupName" }
          }),
          _c("el-table-column", { attrs: { label: "说明", prop: "remark" } }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "260" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.ID > 0
                      ? [
                          scope.row.parentId == -1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addUserGroup(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("新增子用户群")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.updateUserGroup(scope.row)
                                }
                              }
                            },
                            [_vm._v("变更")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteUserGroup(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.dialogTitle, visible: _vm.addDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, rules: _vm.rules }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "父级用户群",
                            prop: "parentGroupName"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off", disabled: true },
                            model: {
                              value: _vm.formData.parentGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "parentGroupName", $$v)
                              },
                              expression: "formData.parentGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户群名称", prop: "groupName" } },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off" },
                            model: {
                              value: _vm.formData.groupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "groupName", $$v)
                              },
                              expression: "formData.groupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "说明", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", autocomplete: "off" },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.dialogTitle, visible: _vm.updateDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.updateDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, rules: _vm.rules }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "父级用户群",
                            prop: "parentGroupName"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "选择父用户群"
                              },
                              model: {
                                value: _vm.formData.parentId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "parentId", $$v)
                                },
                                expression: "formData.parentId"
                              }
                            },
                            [
                              _c("el-option", {
                                key: -1,
                                attrs: { label: "根用户群", value: -1 }
                              }),
                              _vm._l(_vm.tableData, function(item) {
                                return item.ID != _vm.formData.ID
                                  ? _c("el-option", {
                                      key: item.ID,
                                      attrs: {
                                        label: item.groupName,
                                        value: item.ID
                                      }
                                    })
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户群名称", prop: "groupName" } },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off" },
                            model: {
                              value: _vm.formData.groupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "groupName", $$v)
                              },
                              expression: "formData.groupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "说明", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", autocomplete: "off" },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }